import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Loader from '../../Components/Loader'
import { FormikContext, useFormik } from 'formik';
import * as Yup from 'yup';
import masterServices from "../../Services/masterService"
import { toast } from 'react-toastify';

export const EditInsurance = () => {

    const [loader, setLoader] = useState(false)
    const [data, setData] = useState()
    const [isDetailOpen, setIsDetailOpen] = useState()
    const history = useHistory()

    let param = new URLSearchParams(history.location.search)


    useEffect(() => {
        onDetail()
    }, [])

    const formik = useFormik({
        initialValues: {
            insurance_premium: "",
            minimum_aed: "",
        },
        validationSchema: Yup.object({
            insurance_premium: Yup.string().required('Required'),
            minimum_aed: Yup.string().required('Required'),

        }),
        onSubmit: values => {
            let postData = {
                minimum_aed: Number(values.minimum_aed),
                insurance_premium: Number(values.insurance_premium),
                id: param.get("id")
            }
            setLoader(true)
            masterServices.update_insurance(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push("/insurance")
                    toast.success(res.message)
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        }
    });

    const onDetail = () => {
        let postData = {
            id: param.get('id')
        }
        masterServices.get_insurance_details(postData).then(res => {
            if (res.status) {
                setIsDetailOpen(res.data)
                formik.setValues({
                    insurance_premium: res.data.insurance_premium,
                    minimum_aed: res.data.minimum_aed,
                })
            }
        })
    }

    return (
        <div className="row d-flex justify-content-center">
            <div className="col-lg-8">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-6 row">
                                    <div className="col-3">
                                        <label className="form-label">Insurance Premium (%)</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            // required={false}
                                            type="text"
                                            className={'form-control my-2' + (formik.touched.insurance_premium ? !formik.errors.insurance_premium ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('insurance_premium')}
                                            placeholder="Enter Premium"
                                        />
                                        {formik.touched.insurance_premium && formik.errors.insurance_premium ? (
                                            <div className="text-danger">{formik.errors.insurance_premium}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-6 row">
                                    <div className="col-3">
                                        <label className="form-label">Min Aed</label>
                                    </div>
                                    <div className="col-9">
                                        <input

                                            type="number"
                                            className={'form-control my-2' + (formik.touched.minimum_aed ? !formik.errors.minimum_aed ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('minimum_aed')}
                                            placeholder="Enter Amount"

                                        />
                                        {formik.touched.minimum_aed && formik.errors.minimum_aed ? (
                                            <div className="text-danger">{formik.errors.minimum_aed}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
